export default __webpack_public_path__ + "static/media/DNo.38-6.7c08c21d.jpg";